import React from "react";
import ReactDOM from "react-dom/client";
import PolicyGeneration from "./policy-generation";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PolicyGeneration />
  </React.StrictMode>,
);
